var _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _mask5, _g5, _mask6, _g6, _mask7, _g7, _mask8, _g8, _mask9, _g9, _mask10, _g10, _mask11, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStratasys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 25,
    viewBox: "0 0 114 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 8,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3561 4.46367L20.5268 0V4.46367H23.1445V7.44376H20.5268V15.9004C20.5268 16.5562 20.6106 16.9647 20.7784 17.126C20.9462 17.2873 21.4582 17.3681 22.3143 17.3684C22.4423 17.3684 22.5782 17.3664 22.7212 17.361C22.8641 17.3555 23.0047 17.3492 23.1426 17.3391V20.4665L21.1459 20.54C19.1541 20.6088 17.7934 20.2662 17.0638 19.5123C16.5912 19.033 16.3549 18.294 16.3549 17.2953V4.46367H16.3561Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.27 -2.08496H25.2295V22.6336H14.27V-2.08496Z",
    fill: "#003393"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57157 16.4449C4.7623 16.7852 5.02707 17.079 5.34662 17.3049C5.6772 17.5335 6.04702 17.7003 6.43792 17.7971C6.85679 17.9032 7.28757 17.9557 7.71984 17.9535C8.05483 17.9518 8.38869 17.9149 8.71583 17.8433C9.04845 17.7748 9.36854 17.6561 9.66496 17.4914C9.94697 17.3356 10.1902 17.1189 10.3766 16.8573C10.5761 16.5621 10.6759 16.2117 10.6617 15.8565C10.6617 15.1789 10.2137 14.6707 9.3176 14.3319C8.09454 13.9026 6.84143 13.5629 5.56835 13.3155C4.91433 13.1674 4.27633 12.9927 3.65434 12.7912C3.06506 12.6073 2.50568 12.3397 1.99356 11.9969C1.51476 11.6762 1.11452 11.253 0.822315 10.7584C0.512297 10.2015 0.359497 9.5718 0.380045 8.93585C0.342894 8.02804 0.55614 7.12739 0.996782 6.33106C1.39416 5.66815 1.95499 5.11656 2.62645 4.72823C3.33191 4.32448 4.10245 4.04501 4.90396 3.90219C5.75929 3.74259 6.6278 3.66288 7.49811 3.66411C8.36389 3.66168 9.22767 3.74669 10.0761 3.91783C10.8646 4.07108 11.6197 4.36102 12.3068 4.77436C12.9639 5.18174 13.5208 5.73009 13.9364 6.37915C14.3994 7.14502 14.6656 8.01216 14.7115 8.90418H10.44C10.3767 8.03553 10.0499 7.44796 9.45938 7.14146C8.81166 6.82185 8.09522 6.66379 7.37209 6.68095C7.09731 6.68221 6.8228 6.69826 6.54977 6.72903C6.2717 6.75532 5.99952 6.82484 5.74321 6.93505C5.50405 7.03817 5.29275 7.19581 5.12647 7.39518C4.94755 7.62681 4.8575 7.91408 4.87246 8.20559C4.86189 8.58372 5.02541 8.94605 5.31669 9.18995C5.65735 9.46878 6.0496 9.67887 6.4714 9.80841C7.00502 9.9846 7.54899 10.1282 8.10028 10.2384C8.71202 10.3661 9.33415 10.5043 9.96664 10.6528C10.6138 10.7988 11.2525 10.979 11.8802 11.1927C12.4728 11.3897 13.0327 11.6729 13.5414 12.0332C14.0217 12.3785 14.4213 12.8227 14.7127 13.3354C15.0252 13.9269 15.1776 14.5889 15.1549 15.2565C15.1877 16.2028 14.9638 17.1404 14.5067 17.9715C14.0913 18.6843 13.5108 19.2886 12.8132 19.7342C12.0836 20.1929 11.2732 20.5106 10.4247 20.6705C9.52407 20.8511 8.6075 20.9416 7.68873 20.9406C6.75318 20.9427 5.82002 20.8468 4.90475 20.6545C4.04669 20.4845 3.22667 20.1618 2.48427 19.7022C1.77548 19.2553 1.18017 18.6521 0.744731 17.9394C0.260809 17.1033 0.00417276 16.1566 0 15.1923H4.27147C4.2592 15.6283 4.3627 16.0597 4.57157 16.4433V16.4449Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.08496 1.5791H17.2431V23.0257H-2.08496V1.5791Z",
    fill: "#003393"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 3,
    width: 16,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3775 19.4088C44.4347 19.7205 44.5239 20.0256 44.6437 20.3193H49.2287V19.7027C48.9817 19.5991 48.7672 19.4319 48.6072 19.2184C48.4312 18.873 48.3448 18.4895 48.3559 18.1027C48.336 17.3784 48.3261 16.7618 48.3264 16.2528V8.91299C48.3264 6.98439 47.6381 5.67294 46.2615 4.97864C44.793 4.26291 43.1736 3.90559 41.538 3.93641C38.8142 3.93641 36.893 4.64113 35.7743 6.05057C35.0345 7.05371 34.6201 8.25668 34.5861 9.49939H38.6535C38.7185 8.96592 38.9254 8.45925 39.253 8.03144C39.673 7.54199 40.3878 7.29713 41.3974 7.29687C42.1004 7.25719 42.8027 7.38576 43.4453 7.67178C43.9264 7.94892 44.1993 8.48017 44.1427 9.02949C44.1346 9.58071 43.7663 10.0627 43.2338 10.2191C42.6909 10.413 42.125 10.5363 41.5502 10.5858L40.1052 10.7617C38.4661 10.9676 37.2243 11.3103 36.38 11.7899C34.8401 12.6708 34.0703 14.0948 34.0706 16.062C34.0706 17.5796 34.5489 18.7516 35.5057 19.578C36.5209 20.4256 37.8175 20.8679 39.1431 20.8189C40.2259 20.8361 41.2939 20.5675 42.2378 20.0405C42.9887 19.6101 43.6707 19.0708 44.2613 18.4404C44.2904 18.8024 44.3298 19.1253 44.3794 19.4092L44.3775 19.4088ZM44.1278 14.0951C44.0978 15.4946 43.695 16.4589 42.9191 16.988C42.1735 17.5071 41.2841 17.784 40.3734 17.7808C39.8395 17.7961 39.3167 17.6276 38.8938 17.3039C38.4557 16.9118 38.2296 16.3376 38.2837 15.7546C38.2444 15.0217 38.6316 14.3313 39.2797 13.9782C39.8903 13.6855 40.5445 13.4922 41.217 13.4059L42.1767 13.2296C42.5614 13.1658 42.94 13.07 43.3086 12.9434C43.5935 12.8353 43.8672 12.7001 44.1258 12.5396L44.1278 14.0951Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9856 1.84961H51.3137V22.9075H31.9856V1.84961Z",
    fill: "#003393"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 0,
    width: 8,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9035 20.3848C57.1088 19.5519 56.5898 18.4975 56.4164 17.3633C56.3187 17.366 56.2195 17.3684 56.1297 17.3684C55.2719 17.3684 54.7593 17.2877 54.5918 17.1264C54.4243 16.9651 54.3404 16.5565 54.3401 15.9008V7.44376H56.9579V4.46367H54.3401V0L50.3514 4.46367V17.2949C50.3514 18.2936 50.5877 19.0326 51.0603 19.5119C51.7145 20.1882 52.7357 20.5306 54.3756 20.5451V20.5478C56.9031 20.6065 57.8653 20.3883 57.8653 20.3883L57.9011 20.3848H57.9035Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2665 -2.08496H59.9885V22.6429H48.2665V-2.08496Z",
    fill: "#003393"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 3,
    width: 17,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1774 19.4093C68.2345 19.721 68.3238 20.0261 68.4436 20.3198H73.0285V19.7033C72.7818 19.5996 72.5674 19.4324 72.4074 19.2189C72.2314 18.8736 72.1451 18.4901 72.1562 18.1032C72.1362 17.379 72.1263 16.7623 72.1263 16.2533V8.91356C72.1263 6.98495 71.4381 5.6735 70.0618 4.9792C68.5928 4.26263 66.9727 3.90477 65.3362 3.93541C62.6126 3.93541 60.6913 4.64013 59.5726 6.04958C58.8324 7.05299 58.4179 8.25641 58.384 9.49956H62.4534C62.5184 8.9661 62.7253 8.45942 63.0528 8.03161C63.4729 7.54216 64.1877 7.29731 65.1972 7.29705C65.9003 7.25736 66.6026 7.38594 67.2452 7.67195C67.7262 7.94909 67.9992 8.48035 67.9426 9.02966C67.9342 9.58205 67.564 10.0645 67.0297 10.2193C66.4868 10.4132 65.9209 10.5364 65.3461 10.586L63.9007 10.7619C62.2619 10.9678 61.0202 11.3105 60.1755 11.79C58.6362 12.6709 57.8665 14.095 57.8665 16.0622C57.8665 17.5798 58.3449 18.7518 59.3016 19.5782C60.3168 20.4258 61.6134 20.8681 62.939 20.819C64.0218 20.8363 65.0898 20.5676 66.0337 20.0407C66.7847 19.6102 67.4667 19.0709 68.0572 18.4406C68.0864 18.8026 68.1257 19.1255 68.1754 19.4093H68.1774ZM67.9237 14.095C67.8938 15.4946 67.4909 16.4589 66.715 16.9879C65.9694 17.507 65.08 17.784 64.1693 17.7808C63.6354 17.7961 63.1126 17.6276 62.6897 17.3038C62.2524 16.9114 62.027 16.3372 62.0816 15.7545C62.0423 15.0217 62.4295 14.3312 63.0776 13.9781C63.6883 13.6854 64.3424 13.4922 65.0149 13.4058L65.9742 13.2295C66.3591 13.1657 66.7378 13.07 67.1065 12.9433C67.3914 12.8353 67.6651 12.7 67.9237 12.5395V14.095Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7816 1.84863H75.1135V22.9077H55.7816V1.84863Z",
    fill: "#003393"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 4,
    width: 14,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4207 15.5454C76.0004 18.2428 77.4043 19.2412 80.1509 19.2412C82.8065 19.2412 84.0573 17.8476 84.0573 16.3331C84.0573 11.7889 73.9257 15 73.9257 8.82014C73.9257 6.21496 75.9704 4.33691 79.4786 4.33691C82.8967 4.33691 85.1246 5.7302 85.583 9.27479H83.7214C83.3859 6.85101 81.7381 5.97258 79.4487 5.97258C77.1295 5.97258 75.8783 7.06328 75.8783 8.67002C75.8783 12.9414 86.0103 10.2756 86.0103 16.3042C86.0103 19.303 83.2929 20.8781 79.5708 20.8781C75.8487 20.8781 73.711 18.5153 73.5582 15.5465L75.4207 15.5454Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4733 2.25195H88.0953V22.9631H71.4733V2.25195Z",
    fill: "#003393"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 4,
    width: 14,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.829 15.5454C102.409 18.2428 103.813 19.2412 106.56 19.2412C109.215 19.2412 110.466 17.8476 110.466 16.3331C110.466 11.7889 100.333 15 100.333 8.82014C100.333 6.21496 102.379 4.33691 105.886 4.33691C109.304 4.33691 111.532 5.7302 111.99 9.27479H110.129C109.793 6.85101 108.145 5.97258 105.856 5.97258C103.537 5.97258 102.285 7.06328 102.285 8.67002C102.285 12.9414 112.418 10.2756 112.418 16.3042C112.418 19.303 109.701 20.8781 105.978 20.8781C102.256 20.8781 100.118 18.5153 99.9664 15.5465L101.829 15.5454Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8815 2.25195H114.503V22.9631H97.8815V2.25195Z",
    fill: "#003393"
  }))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 4,
    width: 16,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0611 20.7059L90.4472 25.0003H92.336L100.037 4.76172H98.0532L92.987 18.2427L87.9208 4.76172H85.8764L92.0103 20.575L92.0611 20.7059Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7914 2.67676H102.122V27.0853H83.7914V2.67676Z",
    fill: "#003393"
  }))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 3,
    width: 10,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9875 4.0115C33.9189 4.00759 33.8693 4.00407 33.839 4.00095C33.7852 3.99625 33.7186 3.99391 33.6393 3.99391C32.5287 3.94433 31.4371 4.29226 30.5631 4.97437C29.8822 5.6056 29.308 6.3415 28.8626 7.15382V4.37429H24.8396V20.3189H29.0843V12.6976C29.0843 11.4206 29.2471 10.4747 29.5726 9.85986C30.1545 8.7676 31.2933 8.22146 32.9891 8.22146C33.117 8.22146 33.2846 8.22628 33.492 8.23593C33.6405 8.24296 33.8071 8.25704 33.9879 8.27502L33.9875 4.0115Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7546 1.9043H36.0729V22.4039H22.7546V1.9043Z",
    fill: "#003393"
  }))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 4,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.419 4.32956C112.013 4.32956 111.647 4.57238 111.491 4.94479C111.336 5.3172 111.422 5.74584 111.709 6.0308C111.996 6.31577 112.428 6.40093 112.803 6.24657C113.178 6.09221 113.423 5.72873 113.423 5.32565C113.426 5.06047 113.321 4.80528 113.132 4.61776C112.943 4.43024 112.686 4.3262 112.419 4.32916V4.32956ZM113.216 5.32557C113.209 5.76071 112.849 6.10826 112.411 6.10348C111.972 6.09869 111.62 5.74337 111.622 5.30818C111.625 4.87299 111.981 4.5213 112.419 4.52102C112.634 4.51827 112.84 4.60258 112.991 4.75445C113.141 4.90632 113.223 5.11259 113.216 5.32557Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.33 2.24414H115.508V8.40756H109.33V2.24414Z",
    fill: "#003393"
  }))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "mask10",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 4,
    width: 1,
    height: 2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.692 5.35346V5.35072C112.787 5.31506 112.848 5.22072 112.839 5.11968C112.84 5.04924 112.811 4.98178 112.759 4.93344C112.707 4.8851 112.638 4.86023 112.567 4.86479H112.066V5.78583H112.27V5.42539H112.475C112.577 5.42539 112.615 5.468 112.63 5.56495C112.632 5.63957 112.643 5.71367 112.662 5.78583H112.866C112.837 5.71681 112.823 5.64215 112.827 5.5673C112.82 5.47465 112.792 5.3777 112.691 5.3519L112.692 5.35346ZM112.494 5.2806H112.271V5.02102H112.494C112.586 5.02102 112.635 5.06011 112.635 5.14885C112.635 5.2376 112.586 5.2806 112.494 5.2806Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.981 2.7793H114.951V7.87082H109.981V2.7793Z",
    fill: "#003393"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratasys);
export default __webpack_public_path__ + "static/media/stratasys.6bcd8e763dd23d79aff899eeca2d9222.svg";
export { ForwardRef as ReactComponent };